// extracted by mini-css-extract-plugin
module.exports = {"linkRequest":"style_linkRequest__y3o6s"};